import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AnyAction, Dispatch } from 'redux';
import { H3, H5, RectangleButton } from '@shared/ui-components';
import { State } from 'common/interfaces/state';
import { AppUrls } from 'routes/app-urls';
import { AccountSelectors } from 'unit-account/selectors';
import { Styled } from './styled';

interface StateProps {
  hasSelectedCompanyActiveSubscription: boolean;
}

interface ReduxActions {
  goToProductsPage: () => {};
}

export const NotFoundPageComponent: React.SFC<StateProps & ReduxActions> = ({
  hasSelectedCompanyActiveSubscription,
  goToProductsPage,
}) => {
  return (
    <Styled.Container>
      <Styled.Img>
        <img src='https://imageskd.s3.eu-west-2.amazonaws.com/404/404_light.png' />
      </Styled.Img>
      <H3><b>404.</b> That's an error</H3>
      <H5>Oops, you've found a dead link</H5>
      {hasSelectedCompanyActiveSubscription && (
        <Styled.ContentContainer>
          <RectangleButton
            mood={'secondary'}
            onClick={goToProductsPage}
            text={'To The Product Page'}
            width={180}
            height={60}
          />
        </Styled.ContentContainer>
      )}
    </Styled.Container>
  );
};

function mapStateToProps(state: State): StateProps {
  return {
    hasSelectedCompanyActiveSubscription: AccountSelectors.hasSelectedCompanyActiveSubscription(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): ReduxActions {
  return {
    goToProductsPage: () => dispatch(push(AppUrls.products.url())),
  };
}


export const NotFoundPage = connect(mapStateToProps, mapDispatchToProps)(NotFoundPageComponent);
